var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1BC462",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 40.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 27.5a.5.5 0 0 0-.5.5v28a.5.5 0 0 0 .5.5h42a.5.5 0 0 0 .5-.5V28a.5.5 0 0 0-.5-.5H21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 28l21 19 21-19M37.07 42.19L21 56m26-13.81L63.07 56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.7ec8812e727749a03d0904e626d268ad.svg";
export { ForwardRef as ReactComponent };